module.exports = "<p>\n  consultant works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/consultant/consultant.component.html
// module id = ./src/app/planning/consultant/consultant.component.html
// module chunks = main